import React from 'react'
import PropTypes from 'prop-types'
import { css } from '@emotion/core'
import { genUID } from '@entrata/utils'

const st0 = css`
  fill: #ffffff;
`
const st1 = css`
  fill: #fff5e3;
`
const st2 = css`
  fill: #c9cfd3;
`
const st3 = css`
  fill: #273e4f;
`
class ContactUs extends React.Component {
  constructor(props) {
    super(props)
    this.titleId = genUID()
  }

  render() {
    const {
      style = {},
      size = 16,
      height,
      width,
      svgRef,
      title,
      ...props
    } = this.props

    return (
      <svg
        viewBox='0 0 104 104'
        height={height || size}
        width={width || size}
        ref={svgRef}
        aria-labelledby={title ? this.titleId : undefined}
        style={{
          pointerEvents: 'none',
          fill: 'currentColor',
          ...style,
        }}
        {...props}
      >
        {title ? <title id={this.titleId}>{title}</title> : null}
        <path css={st0} d='M84.1,82.4H16.7V2.9h67.4V82.4z' />
        <path
          css={st1}
          d='M1.4,46.5L50,78.1l48.4-31.6V91c0,0,1.2,4-1,5.3s-5.3,1.8-5.3,1.8H6c0,0-3.3-0.6-3.8-1.8s-0.8-4.4-0.8-4.4V46.5 z'
        />
        <path
          css={st2}
          d='M15.5,55.5V36L2.2,45.4L15.5,55.5z M84.1,35.5V55l13.3-9.4L84.1,35.5z'
        />
        <path
          css={st3}
          d='M98.5,42.9l-12.9-8.7V6.7c0-3.6-2.9-6.5-6.5-6.5H20.9c-3.6,0-6.5,2.9-6.5,6.5v27.5L1.5,42.9 c-1,0.7-1.5,1.7-1.5,2.9v47.5c0,3.6,2.9,6.5,6.5,6.5h87c3.6,0,6.5-2.9,6.5-6.5V46.1c0,0,0,0,0,0v-0.2C100,44.7,99.4,43.6,98.5,42.9z M85.6,38.4l10.4,7l-10.4,6.9V38.4z M17.9,6.7c0-1.7,1.3-3,3-3h58.2c1.7,0,3,1.3,3,3v48L50,76.2L17.9,54.7V6.7z M14.4,38.4v14 L4,45.5L14.4,38.4z M96.5,93.3c0,1.7-1.3,3-3,3h-87c-1.7,0-3-1.3-3-3v-44l28.8,19.2L10.9,86.7c-1.8,1.4,0.6,4.2,2.3,2.7l22-18.7 c0,0,0.1-0.1,0.1-0.1L49,79.8c0.6,0.4,1.4,0.4,1.9,0l13.8-9.2c0,0,0.1,0.1,0.1,0.1l22,18.7c1.7,1.5,4-1.2,2.3-2.7L67.7,68.6 l28.8-19.2V93.3z M24.9,15.5h17.7c1,0,1.8-0.8,1.8-1.8S43.6,12,42.6,12H24.9c-1,0-1.8,0.8-1.8,1.8S23.9,15.5,24.9,15.5z M24.9,25.5 h50.2c1,0,1.8-0.8,1.8-1.8S76.1,22,75.1,22H24.9c-1,0-1.8,0.8-1.8,1.8S23.9,25.5,24.9,25.5z M24.9,32.5h50.2c1,0,1.8-0.8,1.8-1.8 S76.1,29,75.1,29H24.9c-1,0-1.8,0.8-1.8,1.8S23.9,32.5,24.9,32.5z M24.9,39.5h50.2c1,0,1.8-0.8,1.8-1.8S76.1,36,75.1,36H24.9 c-1,0-1.8,0.8-1.8,1.8S23.9,39.5,24.9,39.5z M24.9,46.5h50.2c1,0,1.8-0.8,1.8-1.8S76.1,43,75.1,43H24.9c-1,0-1.8,0.8-1.8,1.8 S23.9,46.5,24.9,46.5z M60.8,51.8c0-1-0.8-1.8-1.8-1.8H24.9c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8h34.2 C60.1,53.5,60.8,52.7,60.8,51.8z'
        />
      </svg>
    )
  }
}

ContactUs.propTypes = {
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  svgRef: PropTypes.func,
  style: PropTypes.object,
  title: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}
export { ContactUs }
